<template>
  <div>
    <div class="card bg-white rounded">
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <feather-icon
            class="mr-4"
            icon="MapIcon"
            svgClasses="text-black stroke-current w-36.96 h-36.96"
          ></feather-icon>
          <h1 class="md:lg m-0">Endereço</h1>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <span class="my-2 md:text-base"
            >Ao inserir seu endereço encontraremos vagas mais próximas de sua
            residência.</span
          >
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col vs-w="12" class="p-0">
          <vs-row class="flex justify-center">
            <ValidationObserver
              class="flex flex-column flex-wrap"
              tag="form"
              @submit.prevent="handleForward()"
              v-slot="{ invalid }"
            >
              <vs-col vs-w="12" vs-xs="12">
                <vs-input
                  class="no-icon-border mb-5"
                  name="postalcode"
                  type="number"
                  v-model="payload.postalcode"
                  label="CEP"
                  description-text="Ex: 38400000"
                  @blur="searchCEP"
                />
              </vs-col>
              <vs-col vs-w="4" vs-xs="12" vs-sm="12">
                <vs-input
                  class="w-full no-icon-border mb-3"
                  type="text"
                  label="País"
                  v-model="payload.country"
                />
              </vs-col>
              <vs-col vs-w="4" vs-xs="12" vs-sm="12">
                <label class="vs-select--label">Estado</label>
                <ValidationProvider
                  v-if="payload.country.toLowerCase() === 'brasil'"
                  name="estado"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    class="mb-1"
                    v-model="payload.state"
                    :options="ufOptions"
                    :reduce="uf => uf.value"
                    :disabled="payload.autocomplete"
                    @input="
                      value => calculateProgress({ field: 'state', value })
                    "
                  >
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search"
                        :required="!payload.state"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
                <ValidationProvider
                  v-else-if="
                    payload.country.length > 0 &&
                      payload.country.toLowerCase() !== 'brasil'
                  "
                  name="estado"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <vs-input
                    class="mb-1 w-full"
                    v-model="payload.state"
                    :danger="errors.length > 0"
                    :danger-text="errors[0] || ''"
                  />
                </ValidationProvider>
                <vs-input v-else class="mb-1 w-full" v-model="payload.state" />
              </vs-col>
              <vs-col vs-w="4" vs-xs="12" vs-sm="12">
                <label class="vs-select--label">Cidade</label>
                <ValidationProvider
                  v-if="payload.country.toLowerCase() === 'brasil'"
                  name="cidade"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    class="mb-1"
                    name="city"
                    v-model="payload.city"
                    :options="cityOptions"
                    :reduce="city => city.value"
                    :disabled="payload.autocomplete"
                    @input="
                      value => calculateProgress({ field: 'state', value })
                    "
                  >
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search"
                        :required="!payload.city"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
                <ValidationProvider
                  v-else-if="
                    payload.country.length > 0 &&
                      payload.country.toLowerCase() !== 'brasil'
                  "
                  name="cidade"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <vs-input
                    class="mb-1 w-full"
                    v-model="payload.city"
                    :danger="errors.length > 0"
                    :danger-text="errors[0] || ''"
                  />
                </ValidationProvider>
                <vs-input v-else class="mb-1 w-full" v-model="payload.city" />
              </vs-col>
              <div class="flex flex-wrap w-full mt-2">
                <backward-button @click="handleBackward" />
                <forward-button :disabled="invalid" />
              </div>
            </ValidationObserver>
          </vs-row>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import { ModelSelect } from "vue-search-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import ForwardButton from "@/components/ForwardButton";
import BackwardButton from "@/components/BackwardButton";

export default {
  data: () => ({
    payload: {
      city: "",
      state: "",
      address: "",
      country: "",
      postalcode: "",
      autocomplete: false,
      address_number: "",
      address_complement: "",
      address_neighborhood: ""
    },
    ufOptions: [],
    cityOptions: []
  }),
  watch: {
    "payload.postalcode"(value) {
      if (value === "") {
        this.payload = {
          ...this.payload,
          autocomplete: false
        };
      }
    },
    "payload.country"(country) {
      const countryCapitalize =
        country.charAt(0).toUpperCase() + country.slice(1);

      this.payload = {
        ...this.payload,
        country: countryCapitalize
      };

      if (country.toLowerCase() === "brasil") {
        axios
          .get("https://servicodados.ibge.gov.br/api/v1/localidades/estados")
          .then(response => {
            this.ufOptions = response.data.map(uf => ({
              label: uf.nome,
              value: uf.sigla
            }));
          });
      }
    },
    "payload.state"(uf) {
      if (uf !== "" && this.payload.country.toLowerCase() === "brasil") {
        axios
          .get(
            `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
          )
          .then(response => {
            this.cityOptions = response.data.map(city => ({
              label: city.nome,
              value: city.nome
            }));
          });
      }
    },
    "payload.city"(city) {
      const cityCapitalize = city.charAt(0).toUpperCase() + city.slice(1);

      this.payload = {
        ...this.payload,
        city: cityCapitalize
      };
    }
  },
  created() {
    window.scroll(0, 0);

    this.fetchAddress();

    axios
      .get("https://servicodados.ibge.gov.br/api/v1/localidades/estados")
      .then(response => {
        this.ufOptions = response.data.map(uf => ({
          label: uf.nome,
          value: uf.sigla
        }));
      });

    this.googleAnalytics();
  },
  methods: {
    countryIsFilled() {
      setTimeout(() => {
        return this.payload.country !== "";
      }, 3000);
    },

    validate() {
      const validate = Object.keys(this.payload)
        .filter(key => typeof this.payload[key] === "string")
        .filter(key => this.payload[key] !== "");

      return (
        validate.includes("country") &&
        validate.includes("state") &&
        validate.includes("city")
      );
    },
    async handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail"
        });
        return;
      }

      await this.$store.dispatch("step/decrementCurrentStep");

      const { path } = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: path,
        params
      });
    },

    async handleForward() {
      if (this.validate()) {
        this.$vs.loading({ text: "Enviando..." });

        const { company_label } = this.$router.history.current.params;

        this.$http
          .post(`api/v1/talent/${company_label}/user/talent?step=address`, {
            address: {
              ...this.payload
            }
          })
          .then(async response => {
            this.$vs.loading.close();

            this.$store.dispatch("address/store", {
              ...this.payload,
              id: response.data.data.address.id
            });

            if (this.onEditMode()) {
              this.$router.push({
                name: "dashboard-profile-detail"
              });
              return;
            }

            await this.$store.dispatch("step/completeStep");

            await this.$store.dispatch("step/incrementCurrentStep");

            const { path } = this.$store.getters["step/current"];

            const { params } = this.$router.history.current;

            this.$router.push({
              name: path,
              params
            });
            return;
          })
          .catch(() => {
            this.$vs.loading.close();
          });
        return;
      }

      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail"
        });
        return;
      }

      await this.$store.dispatch("step/incrementCurrentStep");
      await this.$store.dispatch("step/completeStep");

      const { path } = this.$store.getters["step/current"];
      const { params } = this.$router.history.current;

      this.$router.push({
        name: path,
        params
      });
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    doCaclulateProgress(e) {
      this.calculateProgress({ field: e.target.name, value: e.target.value });
    },

    searchCEP(e) {
      if (e.target.value.length <= 7) this.autocomplete = false;
      if (e.target.value.length > 7) {
        this.$vs.loading({
          text: "Buscando..."
        });
        this.$viaCep
          .buscarCep(e.target.value)
          .then(this.autoCompleteAddress)
          .then(response => {
            this.$vs.loading.close();

            this.payload = {
              ...this.payload,
              country: "Brasil",
              city: response.localidade,
              state: response.uf,
              address: response.logradouro,
              autocomplete: true,
              address_complement: response.complemento,
              address_neighborhood: response.bairro
            };
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Falha ao localizar CEP",
              text:
                "Ocorreu uma falha ao localizar o CEP, por favor tente novamente!"
            });
          });
      }
    },

    doAutoCompleteCalculateProgress(data) {
      Object.keys(data).map(field =>
        this.calculateProgress({ field, value: data[field] })
      );
    },

    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/address`)
        : this.$ga.page(`${company_label}/step/address`);
    },

    fetchAddress() {
      this.$vs.loading({
        text: "Carregando..."
      });

      const { company_label } = this.$router.history.current.params;

      this.$http
        .get(`api/v1/talent/${company_label}/user/talent?step=address`)
        .then(response => {
          this.$vs.loading.close();
          const { address } = response.data.data;

          this.payload = {
            ...this.payload,
            ...address,
            autocomplete:
              address.autocomplete === null ? false : address.autocomplete
          };
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    ...mapActions("address", [
      "autoCompleteAddress",
      "updateField",
      "setAddress"
    ]),
    ...mapActions("progress", ["calculateProgress"])
  },
  components: {
    ModelSelect,
    ForwardButton,
    BackwardButton,
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";
</style>
